import axios from 'axios';

export const Api = {
  // ?query=#{query}&radius=#{radius}&user_id=#{user_id}
  querySearch(params) {
    return axios({
      method: 'get',
      url: `/api/locations/search-by-radius`,
      params,
    });
  },
  // ?lat=#{lat}&long=#{long}&radius=#{radius}&user_id=#{user_id}
  latLongSearch(params) {
    return axios({
      method: 'get',
      url: `/api/locations/get_zip_code`,
      params,
    });
  },
};
